import React from 'react';
import PropTypes from 'prop-types';

import Container from '@Theme/hellofinance/components/Container/Container';
import Row from '@Theme/hellofinance/components/Row/Row';
import Column from '@Theme/hellofinance/components/Column/Column';
import Picture from '@Theme/hellofinance/components/Picture/Picture';

import * as styles from './TeamContent.module.scss';

const propTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,

  /**
   * Description content
   */
  description: PropTypes.string,

  /**
   * Bottom section description content
   */
  descriptionBottom: PropTypes.string,

  /**
   * Picture src and alt
   */
  picture: PropTypes.shape({
    xs: PropTypes.string,
    md: PropTypes.string,
    alt: PropTypes.string
  })
};

const TeamContent = ({
  heading,
  description,
  descriptionBottom,
  picture
}) => {
  if (!heading && !description && !descriptionBottom && !picture) {
    return false;
  }

  return <section className={styles.root}>
    <Container classname={styles.rootContainer}>
      <Row>
        <Column
          xs={4}
          md={{
            offset: 1,
            col: 10
          }}>
          {heading && <div className={styles.rootHeading}>{heading}</div>}
          {description && <p className={styles.rootDescription}>{description}</p>}
          {picture && <Picture
            pictureClassname={styles.rootPicture}
            imgClassname={styles.rootImage}
            xs={{ src: picture.xs }}
            md={{ srcSet: picture.md }}
            alt={picture.alt}/>}
          {descriptionBottom && <p className={styles.rootDescriptionBottom}>{descriptionBottom}</p>}
        </Column>
      </Row>
    </Container>
  </section>;
};

TeamContent.propTypes = propTypes;

export default TeamContent;
